module.exports = __webpack_public_path__ + "shang.png?ae8886069229c744ee401fda6c6b5462";


//////////////////
// WEBPACK FOOTER
// ./src/plugin/elTreeTransfer/src/shang.png
// module id = 5
// module chunks = 0